<!-- price-breakdown.component.html -->
<div class="price-breakdown text-small">

    <!-- Base Price -->
    <div class="row row--space-between row--valign-center my--sm">
        <div class="column--8">{{ formatServiceName(rate.serviceName) }}</div>
        <div class="column--4 align-right">
            {{ rate.basePrice | currency:'CAD':'symbol-narrow':'1.2-2' }}
        </div>
    </div>
    <!-- Options -->
    <ng-container *ngIf="rate.options && rate.options.length > 0">
        <div>{{ 'App.ShippingTool.Services.Options.Options' | translate }}</div>
        <div *ngFor="let option of rate.options" class="ml--sm my--sm">
            <div class="row row--space-between row--valign-center">
                <div class="column--8 text-xs">{{ getLabel('App.ShippingTool.Option', option) }}</div>
                <div class="column--4 align-right">
                    @if(option.amount === 0) {
                        {{ 'App.ShippingTool.Summary.Included' | translate }}
                    } @else {
                        {{ option.amount | currency:'CAD':'symbol-narrow':'1.2-2' }}
                    }
                </div>
            </div>
        </div>
    </ng-container>

    <!-- Surcharges -->
    <ng-container *ngIf="rate.surcharges && rate.surcharges.length > 0">
        <div>{{ 'App.ShippingTool.Summary.Surcharges' | translate }}</div>
        <div *ngFor="let surcharge of rate.surcharges" class="ml--sm my--sm">
            <div class="row row--space-between row--valign-center">
                <div class="column--8 text-xs">{{ getLabel('App.ShippingTool.Surcharge', surcharge) }}</div>
                <div class="column--4 align-right">
                    {{ surcharge.amount | currency:'CAD':'symbol-narrow':'1.2-2' }}
                </div>
            </div>
        </div>
    </ng-container>

    <!-- Subtotal -->
    <div class="row row--space-between row--valign-center subtotal">
        <div class="column--8 pt--sm">{{ 'App.ShippingTool.Summary.Subtotal' | translate }}</div>
        <div class="column--4 align-right pt--sm">
            {{ rate.priceBeforeTax | currency:'CAD':'symbol-narrow':'1.2-2' }}
        </div>
    </div>

    <!-- Taxes -->
    <ng-container *ngIf="applicableTaxes.length > 0">
        <div *ngFor="let tax of applicableTaxes" class="ml--sm mt--sm">
            <div class="row row--space-between row--valign-center">
                <div class="column--8 text-xs">{{ tax.name }}</div>
                <div class="column--4 align-right">
                    {{ tax.amount | currency:'CAD':'symbol-narrow':'1.2-2' }}
                </div>
            </div>
        </div>
    </ng-container>

    <!-- Total -->
    <div class="row row--space-between row--valign-center total my--sm bold">
        <div class="column--8 pt--sm">{{ 'App.ShippingTool.Summary.Total' | translate }}</div>
        <div class="column--4 align-right pt--sm">
            {{ rate.totalPrice | currency:'CAD':'symbol-narrow':'1.2-2' }}
        </div>
    </div>
</div>  